<template>
  <div class="lo-h-center or-ft-warning">
    <img src="@/assets/icons/warning.svg" :style="{ width: '24px' }" />
    <label class="text">
      <slot />
    </label>
  </div>
</template>

<style scoped>
.text {
  margin-top: -2px;
}
</style>
